import axios from "axios";
import { Outlet, NavLink, useNavigate } from "react-router-dom";
import { useContext, useState } from "react";
import { Context } from "../../Reducers/Store";
import AlertComponent from "../../components/AlertComponent";

export default function LayoutDashboard() {
  const navigate = useNavigate();
  const [state, dispatch] = useContext(Context);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [downloadingApp, setDownloadingApp] = useState(false);

  const linkClass = ({ isActive }) =>
    `flex items-center gap-3 px-4 py-2 rounded text-sm ${
      isActive
        ? "bg-slate-800 text-white"
        : "text-slate-300 hover:bg-slate-800"
    }`;

  const handleLogout = (e) => {
    e.preventDefault();
    const refreshToken = localStorage.getItem("refreshToken");
    axios.delete(`${process.env.REACT_APP_API}/auth`, {
      data: { refreshToken: refreshToken }
    }).then(res => {
      localStorage.removeItem("jwt");
      localStorage.removeItem("refreshToken");
      dispatch({ type: "SET_LOGGED", payload: null });
      navigate("/login");
    }).catch(error => {
      localStorage.removeItem("jwt");
      localStorage.removeItem("refreshToken");
      dispatch({ type: "SET_LOGGED", payload: null });
      navigate("/login");
    });
  };

  const handleNavClick = () => {
    setSidebarOpen(false);
  };

    const handleDownloadApp = async () => {
      setDownloadingApp(true);
      try {
        const res = await axios.get(`${process.env.REACT_APP_API}/me/app`);
        if (res.data?.data?.url) {
          window.open(res.data.data.url, '_blank');
        } else {
          AlertComponent("Erro", "Não foi possível obter o link de download", { icon: "error" });
        }
      } catch (err) {
        console.error(err);
        AlertComponent("Erro", "Erro ao baixar o aplicativo", { icon: "error" });
      } finally {
        setDownloadingApp(false);
      }
    };

  return (
    <div className="h-screen flex bg-gray-100">
      {/* Overlay mobile */}
      {sidebarOpen && (
        <div 
          className="fixed inset-0 bg-black bg-opacity-50 z-20 lg:hidden"
          onClick={() => setSidebarOpen(false)}
        />
      )}

      {/* Sidebar */}
      <aside className={`
        fixed lg:static inset-y-0 left-0 z-30
        bg-slate-900 text-white flex flex-col
        transform transition-all duration-300 ease-in-out
        ${sidebarOpen ? 'translate-x-0' : '-translate-x-full lg:translate-x-0'}
        ${sidebarCollapsed ? 'lg:w-16' : 'lg:w-64'} w-64
      `}>
        <div className="h-16 flex items-center justify-between px-4 font-semibold border-b border-slate-800">
          {!sidebarCollapsed && <span className="truncate"><img src="https://certificados.qualitycert.com.br/Content/Images/logo-v2-Copia.png" alt="Logo" className="h-8" /></span>}
          
          {/* Botão fechar mobile */}
          <button 
            className="lg:hidden text-white"
            onClick={() => setSidebarOpen(false)}
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>

          {/* Botão colapsar desktop */}
          <button 
            className="hidden lg:block text-white hover:text-slate-300"
            onClick={() => setSidebarCollapsed(!sidebarCollapsed)}
            title={sidebarCollapsed ? "Expandir menu" : "Colapsar menu"}
          >
            <svg className={`w-5 h-5 transition-transform ${sidebarCollapsed ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 19l-7-7 7-7m8 14l-7-7 7-7" />
            </svg>
          </button>
        </div>

        <nav className="flex-1 p-2 space-y-1 overflow-y-auto">
          <NavLink to="/dashboard" className={linkClass} onClick={handleNavClick} title="Dashboard">
            <svg className="w-5 h-5 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
            </svg>
            {!sidebarCollapsed && <span>Dashboard</span>}
          </NavLink>

          {state?.profile?.tipo_usuario === "Sistema" && (
            <NavLink to="/contas" className={linkClass} onClick={handleNavClick} title="Contas">
              <svg className="w-5 h-5 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
              </svg>
              {!sidebarCollapsed && <span>Contas</span>}
            </NavLink>
          )}

          {state?.profile?.tipo_usuario !== "Sistema" && (
            <NavLink to="/clientes" className={linkClass} onClick={handleNavClick} title="Clientes">
              <svg className="w-5 h-5 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
              </svg>
              {!sidebarCollapsed && <span>Clientes</span>}
            </NavLink>
          )}

          {state?.profile?.tipo_usuario === "ContaAdmin" && (
            <NavLink to="/grupos" className={linkClass} onClick={handleNavClick} title="Grupos">
              <svg className="w-5 h-5 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 5a1 1 0 011-1h4a1 1 0 011 1v2a1 1 0 01-1 1H5a1 1 0 01-1-1V5zM14 5a1 1 0 011-1h4a1 1 0 011 1v2a1 1 0 01-1 1h-4a1 1 0 01-1-1V5zM9 17a1 1 0 011-1h4a1 1 0 011 1v2a1 1 0 01-1 1h-4a1 1 0 01-1-1v-2zM12 8v8M7 8v4a1 1 0 001 1h8a1 1 0 001-1V8" />
              </svg>
              {!sidebarCollapsed && <span>Grupos</span>}
            </NavLink>
          )}

          <NavLink to="/usuarios" className={linkClass} onClick={handleNavClick} title="Usuários">
            <svg className="w-5 h-5 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" />
            </svg>
            {!sidebarCollapsed && <span>Usuários</span>}
          </NavLink>

          <NavLink
            to="/alterar-senha"
            className={linkClass}
            onClick={handleNavClick}
            title="Alterar senha"
          >
            <svg
              className="w-5 h-5 shrink-0"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 11c1.657 0 3-1.343 3-3S13.657 5 12 5 9 6.343 9 8s1.343 3 3 3zm0 0c-2.761 0-5 2.239-5 5v1h10v-1c0-2.761-2.239-5-5-5z"
              />
            </svg>
            {!sidebarCollapsed && <span>Alterar Senha</span>}
          </NavLink>

          <button
            onClick={handleDownloadApp}
            disabled={downloadingApp}
            className={`flex items-center gap-3 px-4 py-2 rounded text-sm text-slate-300 hover:bg-slate-800 w-full text-left disabled:opacity-50`}
            title="Baixar App Windows"
          >
            <svg className="w-5 h-5 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
            </svg>
            {!sidebarCollapsed && <span>{downloadingApp ? "Baixando..." : "Baixar App"}</span>}
          </button>
        </nav>

        <button
          onClick={handleLogout}
          className={`m-2 p-2 text-sm text-red-300 hover:text-red-200 hover:bg-slate-800 rounded flex items-center gap-3 ${sidebarCollapsed ? 'justify-center' : ''}`}
          title="Sair"
        >
          <svg className="w-5 h-5 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
          </svg>
          {!sidebarCollapsed && <span>Sair</span>}
        </button>
      </aside>

      {/* Conteúdo */}
      <div className="flex-1 flex flex-col min-w-0">
        <header className="h-16 bg-white shadow px-4 sm:px-6 flex items-center justify-between shrink-0">
          <div className="flex items-center gap-4">
            <button 
              className="lg:hidden text-slate-700"
              onClick={() => setSidebarOpen(true)}
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              </svg>
            </button>
            <span className="font-medium text-slate-700 truncate">
              Painel de Certificados
            </span>
          </div>
          <span className="text-sm text-slate-500 truncate ml-4">
            Olá, {state?.profile?.name}
          </span>
        </header>

        <main className="flex-1 p-4 sm:p-6 overflow-auto">
          <Outlet />
        </main>
      </div>
    </div>
  );
}